<template>
  <section>
    <div class="page">
      <div>
        <h2>Reinstalling ToTok</h2>
        <h3>Uninstalling ToTok</h3>
        <p>
          To uninstall ToTok, go to your phone's Settings > Apps & notifications
          > ToTok > Uninstall.
        </p>
        <h3>
          Installing ToTok
        </h3>
        <ol>
          <li>
            Download ToTok for Android on ToTok’s official website (<a
              href="https://totok.ai/download-android"
              >https://totok.ai/download-android</a
            >) and install it.
          </li>
          <li>
            Open ToTok and Click “Start” button to login.
          </li>
          <li>
            Agree to our terms and Verify your phone number.
          </li>
          <li>
            Lastly, set your profile avatar and type in your name.
          </li>
        </ol>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
